import React, {  useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Expand from 'react-expand-animated';

const Accordion = ({active = false,className,title,size,children,isNewComponent}) => {
  const [activeState, setActive] = useState(active || false)
  const handleActive =  () =>  setActive(!activeState)
  const showHide = activeState ? 'active' : ''

    const headerClass = classNames('accordion-gama-header', showHide)
    const transitions = ["height", "opacity", "background"];
    const contentClass = classNames('accordion-gama-content', showHide)
    return (
      <section className={`accordion-gama-new accordion-gama-new-${size} ${showHide} ${className}`}>
        <div className={headerClass} onClick={handleActive}>
          <div className='flex-1'>{typeof title === 'string' ? <span>{title}</span> : title}</div>
          <div className='accordion-badge-container'><i className='glyph glyph-double-arrow-down' /></div>
        </div>

        {isNewComponent 
        ? <Expand key={title} className={"accordion-collapse"}  open={activeState} duration={300} transitions={transitions}>
          <div className="accordion-gama-content active">
            {!!children && children}
          </div>
        </Expand>
        : <div className={contentClass}>
          {!!children && children}
        </div>
        }
      </section>
    )

}

Accordion.propTypes = {
    children: PropTypes.array.isRequired,
    active: PropTypes.bool.isRequired,
    className: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    size: PropTypes.string,
    isNewComponent: PropTypes.bool

}

export default Accordion
